import { render, staticRenderFns } from "./AModalChangePassword.vue?vue&type=template&id=1fdcd0dc"
import script from "./AModalChangePassword.vue?vue&type=script&lang=js"
export * from "./AModalChangePassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports